export var ProfilingDataType;
(function (ProfilingDataType) {
    ProfilingDataType["LITERAL_TYPE"] = "LITERAL_TYPE";
    ProfilingDataType["TIME_TYPE"] = "TIME_TYPE";
    ProfilingDataType["NUMBER_TYPE"] = "NUMBER_TYPE";
    ProfilingDataType["BOOLEAN_TYPE"] = "BOOLEAN_TYPE";
})(ProfilingDataType || (ProfilingDataType = {}));
//# sourceMappingURL=types.js.map